var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { AuthLoginCancelledError } from '@/plugins/auth-storage';
import MeApiClient from '@/plugins/apis/me-api-client';
var authMutationTail = Promise.resolve();
var boundAuth = null;
var boundSessionId = null;
var enqueueAuth = function (operation) {
    var result = authMutationTail.then(operation);
    // 後続の認証を待たせるキューだけを回復し、各呼出元へは元の失敗を返す
    authMutationTail = result.then(function () { return undefined; }, function () { return undefined; });
    return result;
};
var signInForSession = function (auth, customToken, sessionId, isCurrent) { return __awaiter(void 0, void 0, Promise, function () {
    var credential;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!isCurrent())
                    throw new AuthLoginCancelledError();
                boundAuth = null;
                boundSessionId = null;
                if (!!customToken) return [3 /*break*/, 2];
                return [4 /*yield*/, auth.signOut()];
            case 1:
                _b.sent();
                if (!isCurrent())
                    throw new AuthLoginCancelledError();
                return [2 /*return*/, null];
            case 2: return [4 /*yield*/, auth.signInWithCustomToken(customToken)];
            case 3:
                credential = _b.sent();
                if (!!isCurrent()) return [3 /*break*/, 6];
                if (!(credential.user && ((_a = auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) === credential.user.uid)) return [3 /*break*/, 5];
                return [4 /*yield*/, auth.signOut()];
            case 4:
                _b.sent();
                _b.label = 5;
            case 5: throw new AuthLoginCancelledError();
            case 6:
                boundAuth = auth;
                boundSessionId = sessionId;
                return [2 /*return*/, credential.user];
        }
    });
}); };
export var synchronizeFirebaseAuth = function (auth, customToken, sessionId, isCurrent) {
    return enqueueAuth(function () { return signInForSession(auth, customToken, sessionId, isCurrent); });
};
export var ensureFirebaseAuthSession = function (auth, companyId, sessionId, isCurrent) {
    return enqueueAuth(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, customToken, user;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isCurrent())
                        throw new AuthLoginCancelledError();
                    if (boundAuth === auth && boundSessionId === sessionId && auth.currentUser)
                        return [2 /*return*/, auth.currentUser];
                    return [4 /*yield*/, MeApiClient.fetchMe(companyId)];
                case 1:
                    response = _a.sent();
                    if (!isCurrent())
                        throw new AuthLoginCancelledError();
                    customToken = response.data.user.custom_token;
                    if (!customToken)
                        throw new Error('custom_token が取得できませんでした');
                    return [4 /*yield*/, signInForSession(auth, customToken, sessionId, isCurrent)];
                case 2:
                    user = _a.sent();
                    if (!user)
                        throw new Error('Firebase にログインできませんでした');
                    return [2 /*return*/, user];
            }
        });
    }); });
};
